import "./Header.css";

import React from "react";

interface HeaderProps {
  children?: React.ReactNode;
}

export default function Header(props: HeaderProps) {
  return <header className="loa-header">{props.children}</header>;
}
